var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { searchGames } from "../../../../actions/games/creators";
import GamesList from "../GamesList";
import { SectionGames } from "../styles";
var messages = defineMessages({
    popular: {
        id: "games.popular",
        defaultMessage: "Популярные",
    },
    noGames: {
        id: "games.no_games",
        defaultMessage: "Нет игр",
    },
    loading: {
        id: "loading",
        defineMessages: "Загрузка..."
    }
});
var GamesPopular = /** @class */ (function (_super) {
    __extends(GamesPopular, _super);
    function GamesPopular() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPopularGames = function (params) {
            _this.props.searchGamesAction(__assign(__assign({}, params), { isTop: true }));
        };
        return _this;
    }
    GamesPopular.prototype.render = function () {
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, data = _a.data, isLoading = _a.isLoading, backGamesPage = _a.backGamesPage;
        var games = data.Items;
        return (_jsxs("div", { children: [_jsxs(SectionGames, __assign({ darkTheme: darkTheme }, { children: [intl.formatMessage(messages.popular), _jsx("div", { className: "clear-icon", onClick: backGamesPage })] })), !games.length && !isLoading && (_jsx("h3", __assign({ style: { textAlign: "center", padding: "20px 0" } }, { children: intl.formatMessage(messages.noGames) }))), !games.length && isLoading && (_jsx("div", __assign({ style: { padding: "10px", textAlign: "center" } }, { children: intl.formatMessage(messages.loading) }))), _jsx(GamesList, { fetchData: this.getPopularGames })] }));
    };
    return GamesPopular;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.games, isLoading = _a.isLoading, error = _a.error, data = _a.data;
    var openGamesLoading = state.games.openGame.isLoading;
    return {
        user: state.auth.user,
        isLoading: isLoading,
        error: error,
        data: data,
        openGamesLoading: openGamesLoading,
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    searchGamesAction: searchGames,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GamesPopular));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesPopular/GamesPopular.jsx